export default {
  home: {
    minute: '分钟',
    price_info: '{mianfei}分钟内免费，',
    price_info1: '日封顶{currencyName}{fengding}，',
    price_info3: '押金{currencyName}{yajin}，支持免押金租借',
    price_info2: '全月通会员免按金/免每次租金（48小时内归还），可循环不限次租借，如单次租借逾期归还，请缴付普通会员标准租金。',
    price_info4_title: '服務對象及範圍: ',
    price_info4: '只供香港理工大學學生及教職員使用。此充電服務只提供在理工大學校園內租借及歸還。',
    // feature_1: '四种充电方式，适配所有手机',
    // feature_2: '全国通借通还',
    // feature_3: '特别为无线充电设计',
    feature_1: '优质锂电池，电流充沛',
    feature_2: '香港和澳门各租借点皆可通用',
    feature_3: '充电器内置无线充电+三种主流式插头电线',
    feature_4_title: '使用手續: ',
    feature_4: '請用智能手機(二維碼掃描軟件)掃上二維碼登記手機號碼後，繳付每個充電器的按金{yajin}元。繳付完成後充電器會自動彈出。每次租借可享7天共享充電服務。',
    feature_5_title: '服務費用: ',
    feature_5: '繳付按金後，{currencyName}0 可享7天共享充電服務;逾期7天後歸還充電器，{currencyName}{yajin}元按金不能退還',
    feature_6_title: '退還按金: ',
    feature_6: '歸還充電器後，用戶可用智能手機在充電機的顯示屏上掃二維碼，在閣下賬戶內的錢包，申請退還按金。按金會於最多1個⼯作⽇後，由第三方支付平台原路退還。',
    // tips_1: '余额不足，需充值满{currencyName}{yajin}押金才可用',
    tips_1: '未繳按金，需繳按金{currencyName}{yajin}後使用',
    tips_2: '充值押金{currencyName}{yajin}即可租用，用完即可退',
    tips_3: '当前余额{currencyName}{myyue}，可以直接租借',
    tips_4: '當前按金{currencyName}{myyajin}，可以直接租借',
    tips_5: '您是全月通會員，可以直接租借',
    submit: '立即充值',
    borrow: '立即租借',
    msg_fail_title: '提示',
    msg_fail_content: '租借失败，请重新尝试',
    goborrow: '去租借!!!',
    download_app: '使用APP 下載/打開',
    download: '跳轉至app或應用市場',
    wechat_download_tips: '请点击右上角在浏览器打开下载APP'
  },
  login: {
    code_title: '短信验证',
    phone_number: '请输入{0}位数手机号码',
    verification_code: '请输入短信验证码',
    captcha_code: '验证码',
    send_code: '获取验证码',
    login: '登录',
    submit: '提交',
    agree: '点击登录，表示已阅读并同意',
    readme: '使用条款',
    msg_fail_login: '登录失败',
    msg_success_login: '登录成功',
    exchangesuccess: '兑换成功',
    msg_success_login_code: '領取成功，請下載APP登錄使用',
    msg_fail_user: '获取用户信息出错，是否重试？',
    sign_in_with: '第三方登录',
    no_sms: '没收到短信',
    retry: '重新发送',
    receive: '申请领取',
    invite_pwd: '邀请验证码',
    couponcode: '请输入电子券码',
    vip_agreen_tip: '继续，表示您接受我们的',
    vip_agreen_service: '服务条款',
    vip_agreen_and: '和',
    vip_agreen_policy: '隐私政策'
  },
  confirm: {
    title: '确认付款',
    pay_label: '需支付',
    auth_label: '预授权',
    price_tips: '点击确认付款，表示已阅读并同意《增值协议》',
    auth_tips: '预授权押金{currencyName}{yajin},归还后按实际租金扣取',
    pay_type: '请选择支付方式',
    submit: '确认支付',
    msg_loading: '加载中...',
    msg_fail_title: '提示',
    msg_fail_payment: '发起押金支付失败',
    msg_fail_order: '创建租借订单失败',
    msg_fail_support: '当前环境不支持',
    msg_fail_confirm: '确定',
    msg_fail_retry: '重试',
    msg_fail_cancel: '取消',
    支付宝: '支付宝',
    支付宝HK: '支付宝HK',
    银联: '银联',
    微信: '微信',
    PayPal: 'PayPal',
    paypalsubmsg: '可使用VISA，萬事達，美國運通及大來信用卡信用卡結帳。'
  },
  mine: {
    title: '个人中心',
    wallet: '我的账号',
    deposit: '押金',
    wallet_in: '立即登記',
    nouse: '不适用',
    wallet_out: '提现',
    wallet_log: '充值提现',
    order: '租借订单',
    coupon: '优惠易',
    coupon_cd: '充电券',
    login_tips: '请先登录',
    msg_fail_title: '提示',
    msg_fail_update: '修改失败，请重新尝试',
    msg_loading: '加载中...',
    msg_fail_user: '获取用户信息出错，是否重试？',
    help: '帮助',
    setting: '设置',
    logout: '退出',
    buy: '购买设备',
    prestore: '全月通會員',
    prestore_tips: '每次任用48小時，香港和澳門適用',
    prestore_tips2: '雙月HK$199，全年HK$828',
    prestore_type: '已登記',
    prestore_type2: '尚未登記',
    prestore_date: '有效期至',
    prestore_btn: '立即登記',
    single: '單次租借',
    single_tips: '(直接付費，只須按金HK$198)',
    single_tips1: '(只須按金HK$198)',
    single_tips2: '每小時HK$6，每日最高HK$30',
    balance: '餘額',
    paid: '已繳納',
    unpaid: '未繳納',
    using: '使用中',
    deposit_btn: '繳納按金',
    invitation: '邀請碼',
    invite_btn: '邀請朋友',
    wallet_tips: '退按流程：',
    wallet_tips2: '1.點擊"退還按⾦"',
    wallet_tips3: '2.按⾦將於最多1個⼯作⽇退還'
  },
  msg: {
    loading: '加载中...',
    title: '提示',
    success: '操作成功',
    error: '未知异常，请联系管理员',
    confirm: '确认',
    retry: '重试',
    cancel: '取消',
    title_fail: '错误',
    success_payment: '充值成功',
    success_buy: '购买成功',
    fail_payment: '付款失败',
    keyword: '关键词',
    unpaid_order: '有未付款的订单',
    go_pay: '去支付',
    no_more: '沒有更多了',
    payTitle: '购买充电券',
    paySubTitle: '充电券费用',
    payVipTitle: '购买VIP',
    payVipSubTitle: 'VIP费用',
    payYaJinTitle: '缴纳按金',
    payYaJinSubTitle: '缴纳费用',
    payZuJinTitle: '支付租金',
    confirmpaytip: '请用微信扫码支付后点击“我已支付”'
  },
  result: {
    title: '确认结果',
    price_plan: '计费规则',
    msg_success: '租借成功',
    msg_tips_loading: '正在弹出充电宝，请耐心等待...',
    msg_result_loading: '正在确认支付结果...',
    msg_fail_confirm: '确定',
    btn_usage: '使用说明',
    btn_return: '归还说明',
    deposit: '押金',
    msg_fail_content: '请求失败，请重新尝试',
    price_label: '/小时',
    price_info: '{mianfei}分钟内免费，日封顶{fengding}{ccurrency}，计费满{yajin}{ccurrency}自动扣取押金',
    tips_1: '请按图取走<span class="number">{number}号</span>位置充电宝',
    tips_2: '归还请收好按箭头<span class="highlight">【线朝下方】</span>插入机柜并锁',
    msg_note_usage: '充电宝配有三种充电线，请按需使用',
    msg_note_return: '请把充电线插回相应位置后，把充电宝插入机柜的卡槽中',
    return_info: '整理好充電線，將充電寶插入機櫃空缺位置固定後即可完成歸還。'
  },
  result_msg: {
    loading: '加载中...',
    refresh: '点击刷新'
  },
  order: {
    title: '租借订单',
    in_use: '正在使用',
    ended: '已结束',
    msg_error: '加载失败',
    no_data: '暂无数据'
  },
  order_item: {
    order_number: '订单号',
    venue_rented: '租借地点',
    time_rented: '租借时间',
    venue_returned: '归还地点',
    time_returned: '归还时间',
    charge_standard: '收费标准',
    // charge_standard_info: '每小时{pJifei}{pCurrency}(前{pMian}分钟免费)',
    charge_standard_info: '全月通收费标准：全月通会员每次租借48小时免费;普通会员收费标准：每60分钟内计费6元，每天优惠最多计费30元，每次租借限74小时内归还付费，逾期将以全部按金抵扣。',
    rent_occurred: '租借费用',
    returned: '已归还',
    unreturned: '未归还',
    type_0: '未租借',
    type_1: '租借中',
    type_2: '已撤销',
    type_3: '已归还',
    type_4: '有疑问',
    type_5: '超时归还',
    min: '分',
    unpaid: '未付款',
    payment: '付款'
  },
  setting: {
    title: '设置',
    lang: '选择语言'
  },
  help: {
    title: '帮助'
  },
  wallet_in: {
    title: '增值',
    price_label: '增值金額',
    price_placeholder: '請輸入增值金額',
    balance: '當前結餘',
    price_auto: '預存費用可連續使用, 免除按金{0}',
    price_tips: '點擊確定增值，表示已閱讀並同意',
    price_btn: '《增值條款》',
    submit: '立即續費',
    loading: '加載中...',
    paying: '跳轉到付款頁...',
    msg_title: '提示',
    msg_fail_order: '創建增值訂單失敗',
    msg_fail_payment: '增值支付失敗',
    msg_fail_retry: '重試',
    vip_tips: '登記全月通會員可享任用充電服務',
    price_title: '全月通會員',
    price_1: '(單月費)',
    price_2: '(雙月費)',
    price_sub_title: '享{0}天免費充電服務',
    vip_title: '會員專享充電禮遇',
    vip_tips1: '每次可免費租借48小時',
    vip_tips2: '全港通用',
    rule_title: '使用規則：',
    rule_tips: '1、全月通每次租借必須於48小時内歸還，才可以繼續享用全港任意租借服務，如租借逾期，需按照普通會員的標準補交租金。\n2、租借逾期5天者，會被取消全月通會員資格，并需補交5天租金。\n3、享受包月服務賬戶每次限使用一件充電器。\n4、此會員服務為指定時段的優惠待遇，如有查詢，請聯絡客戶服務熱綫：852-2322 2956。\n5、如有任何爭議，香港充電易有限公司保留最終決定權。'
  },
  wallet_out: {
    title: '余额提现',
    price_label: '提现金额',
    price_placeholder: '请输入提现金额',
    balance: '当前余额',
    balance_all: '全部提取',
    deposit: '押金',
    deposit_tips: '目前有租借中的订单，押金{pcurrencyName}{pyajin}暂不可退',
    submit: '立即提现',
    apply: '申请提现',
    confirm: '确认',
    loading: '加载中...',
    msg_fail_price: '提现金额不正确',
    msg_fail_balance: '提现金额不能大于当前余额',
    msg_title: '错误',
    msg_success_content: '申请提现成功',
    type1: '原路退回',
    type2: '退至商场',
    type3: '预约退回',
    tips_title: '说明',
    tips1: '退還按金:歸還充電器後，用戶可用智能手機在充電機的顯示屏上掃二維碼，在閣下賬戶內的錢包，申請退還按金。按金會於最多1個工作日後，由第三方支付平台原路退還。',
    tips2: '按金將會退還到您填寫的帳戶中，處理帳戶按金退還需要1-7個工作日，請耐心等待。',
    input1: '香港名牌商城手機號:',
    input2: '银行卡号:',
    input3: '开户行支行:',
    input4: '姓名:',
    btn: '提交',
    error_tips: '请输入完整的信息'
  },
  coupon: {
    title: '优惠易',
    title_cd: '充电券',
    input_tips: '请输入优惠券码',
    btn: '领取',
    coupon_type1: '租借优惠券',
    coupon_type2: '商家优惠券',
    deadline: '有效期',
    divide: '至',
    detail: '优惠券详情',
    instructions: '使用说明:',
    restrict: '時間限制:',
    tips1: '1.租借訂單結束時,系統會自動使用此券抵扣消費金額;',
    tips2: '2.一張優惠券只能使用一次,消費金額大於優惠券金額時用戶需要支付剩餘的費用;',
    tips3: '3.消費金額小於此券的金額時,將直接抵扣券。多出之優惠券金額將不獲發新優惠券或換成現金;',
    tips4: 'EASY CHARGGE將保留活動之最終決定權',
    code: '券码',
    category_0: '其　他',
    category_1: '餐饮娱乐',
    category_2: '购物零售',
    category_3: '美容护理',
    coupon_wb_tips: '请在付款前出示本券',
    shop: '门店',
    coupon_toBeUsed: '待用',
    coupon_buy: '购买',
    coupon_haveBeenUsedOrPastDue: '已使用/已过期',
    coupon_pay_fee: 'HK$ {0}',
    coupon_paytype_title: '请选择支付方式',
    coupon_paytype_alipay: '支付宝',
    coupon_paytype_alipayhk: 'AlipayHK',
    coupon_paytype_unionpay: '银联支付',
    coupon_pay_button: '确认支付'
  }
}
